import script from "./EditItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditItem.vue?vue&type=script&setup=true&lang=ts"

import "./EditItem.vue?vue&type=style&index=0&id=68b7ccc2&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b7ccc2"]])

export default __exports__